import {Component, OnInit} from "@angular/core";
import {RoleService} from "../../app/core/role.service";
import {Events} from "ionic-angular";

@Component({
  templateUrl: 'profile.page.html',
})
export class ProfilePage implements OnInit {
  roleSub: any;
  role: string = null;

  constructor(private events: Events,
              private roleService: RoleService
  ) {
  }

  ngOnInit(): void {
    this.roleSub = this.roleService.getRole()
      .subscribe((role) => this.role = role);
  }

  ngOnDestroy(): void {
    this.roleSub.unsubscribe();
  }

  save() {
    this.events.publish('profile_edit_form:submitted');
  }

}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.page.ts